/* =============================================================================
   DiSEGNO: Curated DiSEGNI, the single shared source of truth.
   -----------------------------------------------------------------------------
   Read by BOTH the configurator (disegno.viewer.js hands this list to the
   builder frame, replacing its old built-in list) and the landing page
   (sections/disegno-lp-curated.liquid). Edit a design here once and both update.

   Each design:
     id            stable handle used in links: /pages/disegno-builder-demo?curated=<id>
     name          display name
     jewelry_type  bracelet | necklace | earrings
     note          one short line of copy
     elements      Shopify variant SKUs, in order (bracelet / necklace / matching earrings)
     earring_quantity, match_earrings, earring_1_elements, earring_2_elements  (earrings)
     featured      optional true = eligible for the landing page gallery

   Prices, availability and preorder status are NOT stored here: they are read
   live from Shopify by SKU. A design is hidden automatically if any of its SKUs
   is missing or unavailable in the disegno-builder collection.

   starters: jewelry type -> starter SKU (must match the configurator).
   imagesVersion: bumped by tools/capture-curated.js so new card images bypass the CDN cache.
   art: SKU -> builder artwork key (assets/disegno-el-<key>.png). Add a line when
   a new element with new artwork is added to the configurator.
   ========================================================================== */
window.DisegnoCurated = {
  "imagesVersion": "1790477952098",
  "starters": { "bracelet": "SB-D-1", "necklace": "SN-D-1", "earrings": "SE-D-1" },
  "designs": [
    {
      "id": "roman-holiday",
      "name": "Roman Holiday",
      "jewelry_type": "bracelet",
      "note": "Rubies & diamonds, warm and symmetrical.",
      "elements": [
        "RD-1",
        "OR-1",
        "RD-1",
        "ED-1",
        "RD-1",
        "OR-1",
        "RD-1"
      ]
    },
    {
      "id": "adriatic",
      "name": "Adriatic",
      "jewelry_type": "bracelet",
      "note": "Paraíba & blue sapphire, cool and clear.",
      "elements": [
        "RD-1",
        "RP-1",
        "PRS-B-1",
        "RD-1",
        "CS-CB-1",
        "RP-1"
      ]
    },
    {
      "id": "giardino",
      "name": "Giardino",
      "jewelry_type": "necklace",
      "note": "Emerald & yellow sapphire around an Asscher.",
      "elements": [
        "RD-1",
        "EE-1",
        "RS-Y-1",
        "AD-1",
        "RS-Y-1",
        "EE-1"
      ]
    },
    {
      "id": "amore",
      "name": "Amore",
      "jewelry_type": "bracelet",
      "note": "Hearts & pink sapphire, all the way round.",
      "elements": [
        "RD-1",
        "HHS-P-1",
        "RD-1",
        "HHD-1",
        "RD-1",
        "HHS-P-1",
        "RD-1",
        "HHD-1"
      ]
    },
    {
      "id": "notte-stellata",
      "name": "Notte Stellata",
      "jewelry_type": "bracelet",
      "note": "Marquise & princess, sharp and graphic.",
      "elements": [
        "RD-1",
        "MD-1",
        "PD-1",
        "RD-1",
        "PS-P-1",
        "MD-1",
        "RD-1"
      ]
    },
    {
      "id": "limoncello",
      "name": "Limoncello",
      "jewelry_type": "bracelet",
      "note": "Yellow sapphire & radiant diamond.",
      "elements": [
        "RD-1",
        "RS-Y-1",
        "RD-1",
        "RadD-1",
        "RD-1",
        "RS-Y-1",
        "RD-1"
      ]
    },
    {
      "id": "riviera",
      "name": "Riviera",
      "jewelry_type": "necklace",
      "note": "A classic all-diamond line, oval accents.",
      "elements": [
        "RD-1",
        "OD-1",
        "RD-1",
        "RD-1",
        "OD-1",
        "RD-1",
        "RD-1",
        "OD-1"
      ]
    },
    {
      "id": "smeraldo",
      "name": "Smeraldo",
      "jewelry_type": "necklace",
      "note": "Emerald-cut emeralds, cool and regal.",
      "elements": [
        "RD-1",
        "EE-1",
        "AD-1",
        "EE-1",
        "AD-1",
        "EE-1",
        "RD-1"
      ]
    },
    {
      "id": "habibi-habibi",
      "name": "Habibi, Habibi",
      "jewelry_type": "bracelet",
      "note": "The Habibi script, held between rubies and diamonds.",
      "elements": [
        "RD-1",
        "OR-1",
        "RD-1",
        "AC-HAB-D-1",
        "RD-1",
        "OR-1",
        "RD-1"
      ]
    },
    {
      "id": "notte-in-fiamme",
      "name": "Notte in Fiamme",
      "jewelry_type": "bracelet",
      "note": "Hand on Fire set in yellow sapphire and warm diamond.",
      "elements": [
        "RD-1",
        "RS-Y-1",
        "AC-HF-D-1",
        "RadD-1",
        "RD-1",
        "DPR-1",
        "RD-1"
      ]
    },
    {
      "id": "le-mani",
      "name": "Le Mani",
      "jewelry_type": "bracelet",
      "note": "Three hand signs on a diamond line: Cornuto, Ma Che Vuoi, Milano.",
      "elements": [
        "RD-1",
        "MCC-D-1",
        "RD-1",
        "MCVC-D-1",
        "RD-1",
        "MBC-D-1",
        "RD-1"
      ]
    },
    {
      "id": "dubai-souvenir",
      "name": "Dubai Souvenir",
      "jewelry_type": "bracelet",
      "note": "The Salute and the Kursi chair, between clean diamonds.",
      "elements": [
        "RD-1",
        "AC-DS-D-1",
        "RD-1",
        "AC-K-D-1",
        "RD-1",
        "RD-1"
      ]
    },
    {
      "id": "collab-uno",
      "name": "Collab Uno",
      "jewelry_type": "necklace",
      "note": "Two hero charms, Habibi and Hand on Fire, with emerald accents.",
      "elements": [
        "RD-1",
        "EE-1",
        "AC-HAB-D-1",
        "RD-1",
        "AC-HF-D-1",
        "RD-1",
        "EE-1",
        "RD-1"
      ]
    },
    {
      "id": "cuore-malato",
      "name": "Cuore Malato",
      "jewelry_type": "necklace",
      "note": "Lovesick and Cornuto among pink sapphire and diamond hearts.",
      "elements": [
        "RD-1",
        "HHS-P-1",
        "AC-LS-D-1",
        "RD-1",
        "MCC-D-1",
        "HHD-1",
        "RD-1"
      ]
    },
    {
      "id": "goccia",
      "name": "Goccia",
      "jewelry_type": "earrings",
      "note": "A single ruby drop.",
      "earring_quantity": 1,
      "match_earrings": true,
      "elements": [
        "OR-1",
        "RD-1"
      ]
    },
    {
      "id": "semplice",
      "name": "Semplice",
      "jewelry_type": "earrings",
      "note": "One earring, three clean diamonds.",
      "earring_quantity": 1,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "RD-1",
        "RD-1"
      ]
    },
    {
      "id": "minuetto",
      "name": "Minuetto",
      "jewelry_type": "earrings",
      "note": "A four-stone diamond statement, worn solo.",
      "earring_quantity": 1,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "CD-1",
        "RD-1",
        "RadD-1"
      ]
    },
    {
      "id": "gemelle",
      "name": "Gemelle",
      "jewelry_type": "earrings",
      "note": "Matching Paraíba drops.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RP-1",
        "RD-1"
      ]
    },
    {
      "id": "rugiada",
      "name": "Rugiada",
      "jewelry_type": "earrings",
      "note": "The simplest pair: diamond on diamond.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "OD-1"
      ]
    },
    {
      "id": "fiamma",
      "name": "Fiamma",
      "jewelry_type": "earrings",
      "note": "Ruby and diamond, warm.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "OR-1",
        "RD-1",
        "DPR-1"
      ]
    },
    {
      "id": "cuori",
      "name": "Cuori",
      "jewelry_type": "earrings",
      "note": "Hearts in diamond and pink sapphire.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "VHD-1",
        "RD-1",
        "VHS-P-1"
      ]
    },
    {
      "id": "sole",
      "name": "Sole",
      "jewelry_type": "earrings",
      "note": "Yellow sapphire, bright and even.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RS-Y-1",
        "RD-1",
        "RS-Y-1"
      ]
    },
    {
      "id": "zaffiro",
      "name": "Zaffiro",
      "jewelry_type": "earrings",
      "note": "Blue sapphire line with diamond breaks.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "CS-CB-1",
        "RD-1",
        "PRS-B-1",
        "RD-1"
      ]
    },
    {
      "id": "verde",
      "name": "Verde",
      "jewelry_type": "earrings",
      "note": "Emerald and Asscher, cool and regal.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "EE-1",
        "RD-1",
        "AE-1",
        "RD-1"
      ]
    },
    {
      "id": "notturno",
      "name": "Notturno",
      "jewelry_type": "earrings",
      "note": "Deep blue and purple, evening jewels.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "CS-CB-1",
        "RD-1",
        "PS-P-1",
        "RD-1"
      ]
    },
    {
      "id": "brillante",
      "name": "Brillante",
      "jewelry_type": "earrings",
      "note": "All diamond, four different cuts.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "AD-1",
        "RD-1",
        "MD-1",
        "RD-1"
      ]
    },
    {
      "id": "cascata",
      "name": "Cascata",
      "jewelry_type": "earrings",
      "note": "A five-stone diamond cascade.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "OD-1",
        "CD-1",
        "RadD-1",
        "PD-1"
      ]
    },
    {
      "id": "aurora",
      "name": "Aurora",
      "jewelry_type": "earrings",
      "note": "Colour top to bottom: sapphire, diamond, ruby.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "RS-Y-1",
        "RD-1",
        "PRS-B-1",
        "DPR-1"
      ]
    },
    {
      "id": "lungo",
      "name": "Lungo",
      "jewelry_type": "earrings",
      "note": "A long graphic drop in princess cuts.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "PD-1",
        "RD-1",
        "PS-P-1",
        "RD-1"
      ]
    },
    {
      "id": "rapsodia",
      "name": "Rapsodia",
      "jewelry_type": "earrings",
      "note": "Five stones, every one different.",
      "earring_quantity": 2,
      "match_earrings": true,
      "elements": [
        "RD-1",
        "OR-1",
        "CS-CB-1",
        "RS-Y-1",
        "RD-1"
      ]
    },
    {
      "id": "contrasto",
      "name": "Contrasto",
      "jewelry_type": "earrings",
      "note": "Deliberately mismatched: ruby and emerald.",
      "earring_quantity": 2,
      "match_earrings": false,
      "earring_1_elements": [
        "OR-1",
        "RD-1"
      ],
      "earring_2_elements": [
        "EE-1",
        "RD-1"
      ]
    },
    {
      "id": "duetto",
      "name": "Duetto",
      "jewelry_type": "earrings",
      "note": "Two three-stone drops that don't match.",
      "earring_quantity": 2,
      "match_earrings": false,
      "earring_1_elements": [
        "RD-1",
        "OR-1",
        "RD-1"
      ],
      "earring_2_elements": [
        "RD-1",
        "EE-1",
        "RD-1"
      ]
    },
    {
      "id": "asimmetria",
      "name": "Asimmetria",
      "jewelry_type": "earrings",
      "note": "One short, one long, on purpose.",
      "earring_quantity": 2,
      "match_earrings": false,
      "earring_1_elements": [
        "OD-1",
        "RD-1"
      ],
      "earring_2_elements": [
        "RD-1",
        "RS-Y-1",
        "RD-1",
        "OR-1"
      ]
    }
  ],
  "art": {
    "RD-1": "round-diamond",
    "RP-1": "round-paraiba-sapphire",
    "OD-1": "oval-diamond",
    "OR-1": "oval-ruby",
    "CD-1": "cushion-diamond",
    "CS-CB-1": "cushion-blue-sapphire",
    "RadD-1": "radiant-diamond",
    "RS-Y-1": "radiant-yellow-sapphire",
    "PD-1": "princess-diamond",
    "PS-P-1": "princess-purple-sapphire",
    "DPD-1": "diagonal-princess-diamond",
    "DPR-1": "diagonal-princess-ruby",
    "ED-1": "emerald-cut-diamond",
    "EE-1": "emerald-cut-emerald",
    "AD-1": "asscher-diamond",
    "AE-1": "asscher-emerald",
    "DAD-1": "diagonal-asscher-diamond",
    "DAE-1": "diagonal-asscher-emerald",
    "MD-1": "marquise-diamond",
    "MS-PAD-1": "marquise-padparadscha",
    "PRD-1": "pear-diamond",
    "PRS-B-1": "pear-blue-sapphire",
    "HHD-1": "heart-diamond-h",
    "VHD-1": "heart-diamond-v",
    "HHS-P-1": "heart-pink-sapphire-h",
    "VHS-P-1": "heart-pink-sapphire-v",
    "TD-1": "triangle-diamond",
    "TS-CB-1": "triangle-blue-sapphire",
    "AC-HAB-D-1": "charm-habibi",
    "AC-K-D-1": "charm-kursi",
    "AC-HF-D-1": "charm-hand-on-fire",
    "MCC-D-1": "charm-mano-cornuto",
    "AC-LS-D-1": "charm-lovesick",
    "MBC-D-1": "charm-milano-borsa",
    "MCVC-D-1": "charm-ma-che-vuoi",
    "AC-DS-D-1": "charm-sheikh-mohammed-salute"
  }
};
